export default __webpack_public_path__ + "static/media/ic-working-hrs.be9b7f30.svg";